import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';

import { AcceptableUseComponent } from './acceptable-use/acceptable-use.component';
import { AccountComponent } from './account/account.component';
import { AddAddressComponent } from './account/add-address/add-address.component';
import { BootstrapThemeKitComponent } from './bootstrap-theme-kit/bootstrap-theme-kit.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CookiesComponent } from './cookies/cookies.component';
import { EditMyPetComponent } from './my-pets/my-pet/edit/edit-my-pet.component';
import { ForgotPasswordComponent } from './account/forgot-password/forgot-password.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './account/login/login.component';
import { LoginRegisterComponent } from './account/login-register/login-register.component';
import { SocialLandingPageComponent } from './social-landing-page/social-landing-page.component';
import { LostAndFoundComponent } from './lost-and-found/lost-and-found.component';
import { MicrochippingYourPetComponent } from './microchipping-your-pet/microchipping-your-pet.component';
import { MicrochippingYourPetV2Component } from './microchipping-your-pet/microchipping-your-pet-v2/microchipping-your-pet-v2.component';
import { MicrochippingYourPetWrapperComponent } from './microchipping-your-pet/microchipping-your-pet-wrapper/microchipping-your-pet-wrapper.component';
import { MissingPetComponent } from './lost-and-found/missing-pets/missing-pet/missing-pet.component';
import { MissingPetsComponent } from './lost-and-found/missing-pets/missing-pets.component';
import { MyPetComponent } from './my-pets/my-pet/my-pet.component';
import { MyPetsComponent } from './my-pets/my-pets.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { RegisterComponent } from './account/register/register.component';
import { ClaimPetByChipComponent } from './my-pets/claim-pet/claim-by-chip/claim-by-chip.component';
import { RegisterUserDetailsConfirmationComponent } from './account/register/user-details-confirmation/user-details-confirmation.component';
import { ReportMissingPetComponent } from './my-pets/my-pet/report-missing/report-missing.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { UpdateAddressComponent } from './account/update-address/update-address.component';
import { UpdateEmailComponent } from './account/update-email/update-email.component';
import { UpdatePasswordComponent } from './account/update-password/update-password.component';
import { UpdateTelephoneComponent } from './account/update-telephone/update-telephone.component';
import { UpgradeAccountComponent } from './account/upgrade-account/upgrade-account.component';
import { UpgradeAccountWrapperComponent } from './account/upgrade-account-wrapper/upgrade-account-wrapper.component';
import { WebsiteUseComponent } from './website-use/website-use.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SetNewPasswordComponent } from './account/set-new-password/set-new-password.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { QrCodePageComponent } from './qr-code/qr-code-page.component';
import { InvoicesComponent } from './account/invoices/invoices.component';
import { ActivateEmailComponent } from './account/activate-email/activate-email.component';
import { SentEmailComponent } from './account/sent-email/sent-email.component';
import { OwnerDetailsComponent } from './account/owner-details/owner-details.component';
import { ClaimAccountComponent } from './account/claim-account/claim-account.component';
import { MembershipOptionsComponent } from './account/membership-options/membership-options.component';
import { PetplanWelcomePackComponent } from './petplan-application/petplan-welcome-gift/petplan-welcome-gift.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IdentibaseSubAppreciationComponent } from './account/identibase-sub-appreciation/identibase-sub-appreciation.component';
import { ActivateNoEmailUserComponent } from './account/activate-no-email-user/activate-no-email-user.component';
import { IdentibasePlusPageComponent } from '../shared/components/subscription-pages/identibasePlus/identibase-plus-page.component';
import { IdentialertPageComponent } from '../shared/components/subscription-pages/identialert/identialert-page.component';
import { RehomePetComponent } from './my-pets/rehome-pet/rehome-pet.component';
import { ChoosePlanComponent } from './choose-plan/choose-plan.component';
import { PlansPageComponent } from './plans-page/plans-page.component';
import { ChoosePlanWrapperComponent } from './choose-plan/choose-plan-wrapper/choose-plan-wrapper.component';
import { UpdateDateOfBirthComponent } from './account/update-date-of-birth/update-date-of-birth.component';
import { UpdateGenderComponent } from './account/update-gender/update-gender.component';
import { UpdateTitleComponent } from './account/update-title/update-title.component';
import { QrCodePreferencesPageComponent } from './qr-code/preferences/qr-code-preferences-page.component';
import { PetDeceasedComponent } from './qr-code/pet-deceased/pet-deceased.component';
import { CheckPetsChipComponent } from './check-pets-chip/check-pets-chip.component';
import { TokClaimAccountComponent } from './account/tok-register/tok_claim_account.component';
import { TokLoginComponent } from './account/tok-login/tok-login.component';
import { TokPaymentComponent } from './tok-payment/tok-payment.component';
import { TokPaymentV2Component } from './tok-payment/tok-payment-v2/tok-payment-v2.component';
import { TokPaymentWrapperComponent } from './tok-payment/tok-payment-wrapper/tok-payment-wrapper.component';
import { TokDetailsComponent } from './tok-details/tok-details.component';
import { IdentiProfessionalsComponent } from './identi-professionals/identi-professionals.component';
import { IdentibaseReviewComponent } from './identibase-review/identibase-review.component';
import { MissingPetReportComponent } from './lost-and-found/missing-pets/missing-pet-report/missing-pet-report.component';
import { TokConsentComponent } from './tok-consent/tok-consent.component';
import { B2cLoginComponent } from './b2c-login/b2c-login';
import { IdentiSmartTagProductPageComponent } from './identi-smart-tag-product-page/identi-smart-tag-product-page.component';
import { OwnerDetailsV2Component } from './account/owner-details-v2/owner-details-v2.component';
import { ProgressBarComponent } from './account/progress-bar/progress-bar.component';
import { EditV2Component } from './my-pets/my-pet/edit-v2/edit-v2.component';
import { EditPetWrapperComponent } from './my-pets/my-pet/edit-pet-wrapper/edit-pet-wrapper.component';
import { OwnerDetailsComponentWrapper } from './account/owner-details-wrapper/owner-details-wrapper.component';
import { ContactUsV2Component } from './contact-us/contact-us-v2/contact-us-v2.component';
import { ContactUsWrapperComponent } from './contact-us/contact-us-wrapper/contact-us-wrapper.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { IdentiSmartTagComponent } from './identi-smart-tag/identi-smart-tag.component';
import { StoryTimelineItemComponent } from './about-us/story-timeline-item/story-timeline-item.component';
import { LostAndFoundV2Component } from './lost-and-found/lost-and-found-v2/lost-and-found-v2.component';
import { GuidanceAccordionItemComponent } from './lost-and-found/lost-and-found-v2/guidance-accordion-item/guidance-accordion-item.component';
import { LostAndFoundWrapperComponent } from './lost-and-found/lost-and-found-wrapper/lost-and-found-wrapper.component';
import { PetplanApplicationLiteComponent } from './petplan-application-lite/petplan-application-lite.component';
import { MembershipOptionsV2Component } from './account/membership-options/membership-options-v2/membership-options-v2.component';
import { MembershipOptionsWrapperComponent } from './account/membership-options/membership-options-wrapper/membership-options-wrapper.component';
import { IdentibasePlusV2Component } from '../shared/components/subscription-pages/identibase-plus-v2/identibase-plus-v2.component';
import { PlanComparisonTableComponent } from '../shared/components/plan-comparison-table/plan-comparison-table.component';
import { IdentialertV2Component } from '../shared/components/subscription-pages/identialert-v2/identialert-v2.component';
import { OwnerPrivacyPolicyComponent } from './owner-privacy-policy/owner-privacy-policy.component';
import { OwnerTermsAndConditionsComponent } from './owner-terms-and-conditions/owner-terms-and-conditions.component';
import { FinderTermsOfUseComponent } from './finder-terms-of-use/finder-terms-of-use.component';
import { FinderPrivacyPolicyComponent } from './finder-privacy-policy/finder-privacy-policy.component';

@NgModule({
  declarations: [
    AcceptableUseComponent,
    AccountComponent,
    AddAddressComponent,
    BootstrapThemeKitComponent,
    ContactUsComponent,
    ContactUsV2Component,
    ContactUsWrapperComponent,
    AboutUsComponent,
    IdentiSmartTagComponent,
    StoryTimelineItemComponent,
    LostAndFoundV2Component,
    GuidanceAccordionItemComponent,
    LostAndFoundWrapperComponent,
    CookiesComponent,
    DashboardComponent,
    EditMyPetComponent,
    EditV2Component,
    EditPetWrapperComponent,
    OwnerDetailsComponentWrapper,
    ForgotPasswordComponent,
    HomeComponent,
    InvoicesComponent,
    LoginComponent,
    LoginRegisterComponent,
    LostAndFoundComponent,
    MicrochippingYourPetComponent,
    MicrochippingYourPetV2Component,
    MicrochippingYourPetWrapperComponent,
    MissingPetComponent,
    MissingPetsComponent,
    MissingPetReportComponent,
    MyPetComponent,
    MyPetsComponent,
    NotFoundComponent,
    QrCodePageComponent,
    QrCodePreferencesPageComponent,
    PrivacyComponent,
    RegisterComponent,
    ClaimPetByChipComponent,
    RegisterUserDetailsConfirmationComponent,
    ReportMissingPetComponent,
    SetNewPasswordComponent,
    TermsAndConditionsComponent,
    UpdateAddressComponent,
    UpdateEmailComponent,
    UpdatePasswordComponent,
    UpdateTelephoneComponent,
    UpdateDateOfBirthComponent,
    UpdateGenderComponent,
    UpdateTitleComponent,
    UpgradeAccountComponent,
    UpgradeAccountWrapperComponent,
    WebsiteUseComponent,
    ActivateEmailComponent,
    SentEmailComponent,
    OwnerDetailsComponent,
    OwnerDetailsV2Component,
    ProgressBarComponent,
    ClaimAccountComponent,
    MembershipOptionsComponent,
    MembershipOptionsV2Component,
    MembershipOptionsWrapperComponent,
    PetplanWelcomePackComponent,
    PetplanApplicationLiteComponent,
    IdentibaseSubAppreciationComponent,
    ActivateNoEmailUserComponent,
    IdentibasePlusPageComponent,
    IdentialertPageComponent,
    ChoosePlanComponent,
    PlansPageComponent,
    ChoosePlanWrapperComponent,
    SocialLandingPageComponent,
    RehomePetComponent,
    PetDeceasedComponent,
    CheckPetsChipComponent,
    TokClaimAccountComponent,
    TokLoginComponent,
    TokLoginComponent,
    TokPaymentComponent,
    TokPaymentV2Component,
    TokPaymentWrapperComponent,
    TokDetailsComponent,
    IdentiProfessionalsComponent,
    IdentibaseReviewComponent,
    TokConsentComponent,
    B2cLoginComponent,
    IdentiSmartTagProductPageComponent,
    PlanComparisonTableComponent,
    IdentibasePlusV2Component,
    IdentialertV2Component,
    OwnerPrivacyPolicyComponent,
    OwnerTermsAndConditionsComponent,
    FinderTermsOfUseComponent,
    FinderPrivacyPolicyComponent
  ],
  imports: [SharedModule, ReactiveFormsModule, FormsModule],
})
export class PagesModule {}

export const RoutingComponents = {
  AcceptableUseComponent,
  AccountComponent,
  AddAddressComponent,
  BootstrapThemeKitComponent,
  ContactUsComponent,
  ContactUsWrapperComponent,
  AboutUsComponent,
  IdentiSmartTagComponent,
  LostAndFoundWrapperComponent,
  CookiesComponent,
  DashboardComponent,
  EditMyPetComponent,
  EditV2Component,
  EditPetWrapperComponent,
  OwnerDetailsComponentWrapper,
  ForgotPasswordComponent,
  HomeComponent,
  InvoicesComponent,
  LoginComponent,
  LoginRegisterComponent,
  LostAndFoundComponent,
  MicrochippingYourPetComponent,
  MicrochippingYourPetWrapperComponent,
  MissingPetComponent,
  MissingPetsComponent,
  MissingPetReportComponent,
  MyPetsComponent,
  MyPetComponent,
  NotFoundComponent,
  QrCodePageComponent,
  QrCodePreferencesPageComponent,
  PrivacyComponent,
  RegisterComponent,
  ClaimPetByChipComponent,
  RegisterUserDetailsConfirmationComponent,
  ReportMissingPetComponent,
  SetNewPasswordComponent,
  TermsAndConditionsComponent,
  UpdateAddressComponent,
  UpdateEmailComponent,
  UpdatePasswordComponent,
  UpdateTelephoneComponent,
  UpdateDateOfBirthComponent,
  UpdateGenderComponent,
  UpdateTitleComponent,
  UpgradeAccountComponent,
  UpgradeAccountWrapperComponent,
  WebsiteUseComponent,
  ActivateEmailComponent,
  SentEmailComponent,
  OwnerDetailsComponent,
  OwnerDetailsV2Component,
  ProgressBarComponent,
  ClaimAccountComponent,
  MembershipOptionsComponent,
  MembershipOptionsWrapperComponent,
  PetplanWelcomePackComponent,
  PetplanApplicationLiteComponent,
  IdentibaseSubAppreciationComponent,
  ActivateNoEmailUserComponent,
  IdentibasePlusPageComponent,
  IdentialertPageComponent,
  ChoosePlanWrapperComponent,
  SocialLandingPageComponent,
  RehomePetComponent,
  PetDeceasedComponent,
  CheckPetsChipComponent,
  TokClaimAccountComponent,
  TokLoginComponent,
  TokPaymentComponent,
  TokPaymentWrapperComponent,
  TokDetailsComponent,
  IdentiProfessionalsComponent,
  IdentibaseReviewComponent,
  TokConsentComponent,
  B2cLoginComponent,
  IdentiSmartTagProductPageComponent,
  IdentibasePlusV2Component,
  PlanComparisonTableComponent,
  IdentialertV2Component,
  OwnerPrivacyPolicyComponent,
  OwnerTermsAndConditionsComponent,
  FinderTermsOfUseComponent,
  FinderPrivacyPolicyComponent
};
